export default __webpack_public_path__ + "static/media/filter.3470c9c2.svg";